import { REWARDS_BULK_UPLOAD_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds';
import { ACCOUNT_SETTINGS_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds';
import { colorsNew } from 'root/src/client/web/commonStyles';
const TEMPLATE_FILE_URL = 'https://docs.google.com/spreadsheets/d/1m9JgBhPRpYFQ958u0z6Lzhy8flMeFYsVAFJykezktZE/edit#gid=0';
export const rewardsBulkUploadForm = {
    [REWARDS_BULK_UPLOAD_FORM_MODULE_ID]: {
        moduleType: 'form',
        subTitle: [{
                text: 'Upload your keys and codes all at once by copying this template file.',
                linkLabel: 'template file',
                linkStyles: {
                    color: colorsNew.blue,
                    textDecoration: 'underline',
                },
                href: TEMPLATE_FILE_URL,
            }],
        fields: [
            {
                labelFieldText: [
                    {
                        text: 'Keys and Codes',
                        required: true,
                    },
                ],
                fieldId: 'templateFile',
                inputType: 'attachmentInput',
                attachmentFormats: ['csv'],
                subFieldText: 'Filled template file',
                required: true,
            },
        ],
        submits: [
            {
                label: 'Upload',
                buttonType: 'primaryButton',
            },
        ],
        links: [
            {
                routeId: ACCOUNT_SETTINGS_ROUTE_ID,
                label: 'Go Back',
                dynamicPreviousRoute: true,
            },
        ],
    },
};
